import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';

import { AuthSession } from '@core/auth/auth-session';

export const authGuard: CanActivateFn = (_route, state) => {
  if (inject(AuthSession).isAuthenticated()) {
    return true;
  }
  return inject(Router).createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
};

/** Keeps signed-in users off the login page, e.g. after a reload restored their session. */
export const guestGuard: CanActivateFn = () => {
  if (!inject(AuthSession).isAuthenticated()) {
    return true;
  }
  return inject(Router).createUrlTree(['/']);
};
